module.exports = __webpack_public_path__ + "static/media/Q_2_14.d62c525f.jpg";